import { Component, OnInit } from '@angular/core'
import { ModalEditMenuComponent } from '@cms/system/modal/modal-edit-menu/modal-edit-menu.component'
import { NzModalService } from 'ng-zorro-antd'
import { KetMoveLayerManuComponent } from '../move-layer-manu'
import { KetAddMenuPageComponent } from '../add-menu-page'
import {
  GetMenuSetting,
  MenuListStore,
  MenuSettingSelectorLevel1,
  MenuSettingSelectorLevel2,
  MenuSettingSelectorLevel3,
  MenuSettingStore,
} from '@cms/store/MenuSetting'

@Component({
  selector: 'ket-headers-menu',
  templateUrl: './headers-menu.component.html',
  styleUrls: ['./headers-menu.component.scss'],
})
export class KetHeadersMenuComponent implements OnInit {
  constructor(private modal: NzModalService) {}

  // new state
  MenuSettingStore = MenuSettingStore
  SelectorLevel = -1
  message_duration = 4000
  sort_options = {
    group: 'level-0',
  }

  ngOnInit(): void {
    this.SelectorLevel = MenuSettingSelectorLevel1.get().page_id
  }

  edit(data: ReturnType<typeof MenuSettingStore.get>['changing']['menu'][0], edit_detail = false) {
    // console.log(data)
    let edit_menu = data
    if (edit_detail && ['Products', 'Blog'].includes(data.page)) {
      edit_menu = data.detail
    }
    const modal = this.modal
      .create({
        nzTitle: 'แก้ไขเมนู',
        nzContent: ModalEditMenuComponent,
        nzStyle: { top: '20px' },
        nzWidth: '70%',
        nzKeyboard: false,
        nzMaskClosable: false,
        nzOnOk: (componentInstance) => {
          return componentInstance.ok()
        },
        nzOnCancel: () => {},
        nzComponentParams: {
          data: {
            page: edit_menu,
          },
        },
      })
      .afterClose.subscribe((result) => {
        modal.unsubscribe()
        console.log(result)
        if (result) {
          // this.select.emit()
        }
      })
  }

  moveLayerMenu(data: ReturnType<typeof MenuSettingStore.get>['changing']['menu'][0]) {
    const modal = this.modal
      .create({
        nzTitle: 'ย้ายตำแหน่ง Layer',
        nzContent: KetMoveLayerManuComponent,
        nzWrapClassName: 'vertical-center-modal',
        nzWidth: '45%',
        nzKeyboard: false,
        nzMaskClosable: false,
        nzComponentParams: {
          data: {
            page: data,
          },
        },
        nzOnOk: (componentInstance) => {
          return componentInstance.ok()
        },
      })
      .afterClose.subscribe((result) => {
        modal.unsubscribe()
        console.log(result)
        if (result) {
          // this.select.emit()
        }
      })
  }

  addMenu() {
    this.modal.create({
      nzTitle: 'Add Menu',
      nzContent: KetAddMenuPageComponent,
      nzWrapClassName: 'vertical-center-modal',
      nzWidth: '45%',
      nzKeyboard: false,
      nzMaskClosable: false,
      nzComponentParams: {
        add_type: 'main',
      },
      nzOnOk: (componentInstance) => {
        return componentInstance.ok()
      },
    })
  }

  async ToggleEnable(data: ReturnType<typeof MenuSettingStore.get>['changing']['menu'][0]) {
    console.log(data)
    const state = MenuSettingStore.get()
    console.log(
      'Store',
      state.changing.menu.find((x) => x.page_id === data.page_id),
    )
  }

  onDelete(data: ReturnType<typeof MenuSettingStore.get>['changing']['menu'][0]) {
    const list_state = MenuListStore.get()
    list_state.push(data)
    MenuListStore.set(list_state)
    const state = MenuSettingStore.get()
    state.changing.menu = state.changing.menu.filter((x) => x.page_id !== data.page_id)
  }

  onChange(page_id: number) {
    const data = MenuSettingStore.get().changing.menu.find((x) => x.page_id === page_id)
    MenuSettingSelectorLevel2.set(undefined)
    MenuSettingSelectorLevel3.set(undefined)
    GetMenuSetting('main', data.page_id)
    for (const item of data.childrens) {
      GetMenuSetting('sub', item.page_id)
    }
    MenuSettingSelectorLevel1.set(data)
  }

  onMoveNext(data: ReturnType<typeof MenuSettingStore.get>['changing']['menu'][0], p: 'next' | 'prev') {
    // console.log('onMoveNext', data, p)
    const menu = MenuSettingStore.get().changing.menu
    const oldIndex = menu.findIndex((x) => x.page_id === data.page_id)
    if (p === 'next' && oldIndex == menu.length -1) return
    if (p === 'prev' && oldIndex == 0) return
    const newIndex = p === 'next' ? oldIndex + 1 : oldIndex - 1
    const newItem = menu[oldIndex]
    const oldItem = menu[newIndex]
    menu[oldIndex] = oldItem
    menu[newIndex] = newItem
  }
}
